class scheduleSlider extends HTMLElement {
	constructor() {
		super();
        this.bannerCountDownItems = this.querySelectorAll('.banner_countdown');
        this.setup();
	}

    //needs refactoring because the countdown should be the custom element itself
    setup() {
        this.bannerCountDownItems.forEach((value, index, array) => {
            this.enableBannerCountDown(value);
        });
    }
	
	getCurrentDateTime(timezone) {
        const date = new Date();
        const year = date.toLocaleString('default', {
            timeZone: timezone,
            year: 'numeric'
        });
        const month = date.toLocaleString('default', {
            timeZone: timezone,
            month: '2-digit',
        });
        const day = date.toLocaleString('default', {
            timeZone: timezone,
            day: '2-digit'
        });

        var hour = date.toLocaleTimeString('default', {
            timeZone: timezone,
            hour: '2-digit',
            hour12: false
        });
      
        var minute = date.toLocaleTimeString('default', {
            timeZone: timezone,
            minute: '2-digit'
        });
        var second = date.toLocaleTimeString('default', {
            timeZone: timezone,
            second: '2-digit'
        });
        
        if(minute.length == 1) {
        	minute = '0' + minute;
        }
        if(second.length == 1) {
        	second = '0' + second;
        }
        
        return [year, month, day].join('-') + ' ' + [hour, minute, second].join(':');
    }
	
    /* needs refactoring : 
    ** avoid use of var inside scope of a function 
    ** avoid assignment of this to a variable instead use bind method
    ** abstract method countdown in utilities.js
    */
	enableBannerCountDown(bannerDiv) {
        var dateTo = bannerDiv.getAttribute('data-countdown-date-to');
        var timezone = bannerDiv.getAttribute('data-timezone');
        var bckColor = bannerDiv.getAttribute('data-background-color');
        var currentDate = DateUtils.getCurrentDate(timezone);
                
        if (dateTo == "" || dateTo < currentDate) {
            return true;
        }
                
        var countDownDate = new Date(dateTo).getTime();
        var obj = this;
        var x = setInterval(function() {
        	var currentDateTime = obj.getCurrentDateTime(timezone);
        	var currentTimestamp = new Date(currentDateTime.replace(' ', 'T')).getTime();
            var distance = countDownDate - currentTimestamp;

            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            
            var stringValues = [];
            if(days > 0) {
            	stringValues.push(days + "d");
            	stringValues.push(hours + "h");
            	stringValues.push(minutes + "m");
            	stringValues.push(seconds + "s");
            } else {
            	if(hours > 0) {
            		stringValues.push(hours + "h");
                	stringValues.push(minutes + "m");
                	stringValues.push(seconds + "s");
            	} else {
            		if(minutes > 0) {
            			stringValues.push(minutes + "m");
                    	stringValues.push(seconds + "s");
            		} else {
            			stringValues.push(seconds + "s");
            		}
            	}
            }

            bannerDiv.innerHTML = stringValues.join(' ');
            bannerDiv.style.backgroundColor = bckColor;
            

            if (distance < 0) {
                clearInterval(x);
                bannerDiv.innerHTML = '';
                bannerDiv.style.backgroundColor = "transparent";
            }
        }, 1000);
    }
}

customElements.define('schedule-slider', scheduleSlider);